"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ServiceItemDuration;
var _react = _interopRequireDefault(require("react"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
/* eslint-disable react/prop-types */

function ServiceItemDuration(_ref) {
  var _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? undefined : _ref$duration,
    _ref$durationUnit = _ref.durationUnit,
    durationUnit = _ref$durationUnit === void 0 ? 'minutes' : _ref$durationUnit,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? ':' : _ref$separator,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  if ((0, _isNil2["default"])(duration)) {
    return null;
  }
  var finalClassname = "duration-information ".concat(className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: finalClassname
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Duration", separator, " "), "".concat(duration, " ").concat(durationUnit));
}